import { AssetfiAssetType } from '@/types/asset-type';

export default function CheckBoxSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="0.564453" width="19" height="19" rx="1.5" fill="white" stroke="#DFDFDF" />
      <path d="M5.5 9.34082L9.33016 13.171L16.1066 6.39454" stroke="#DFDFDF" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
